import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { setNewbuildingBrokerOfferBookingLoading } from 'shared/actions/newbuildingBrokerOfferBooking';
import { checkBookingExists } from 'shared/actions/newbuildingBrokerOfferBooking/checkBookingExists';
import { TSource } from 'shared/types/newbuildingBrokerOfferBooking';
import { trackBookingButtonClick } from 'shared/utils/newbuildingBroker/offerBooking';

import { useOfferBookingUrl } from './useOfferBookingUrl';

export function useBookingButtonClickHandler(source: TSource, gaLabel: string) {
  const offerBookingUrl = useOfferBookingUrl(source);

  const dispatch = useDispatch();

  const pageShowHandler = useCallback(
    (event: PageTransitionEvent) => {
      if (event.persisted) {
        dispatch(setNewbuildingBrokerOfferBookingLoading(false));
      }

      window.removeEventListener('pageshow', pageShowHandler);
    },
    [dispatch],
  );

  const navigationHandler = useCallback(() => {
    // Для скрытия индикатора загрузки при восстановлении страницы из back forward cache.
    window.addEventListener('pageshow', pageShowHandler);

    window.open(offerBookingUrl, '_self');
  }, [offerBookingUrl, pageShowHandler]);

  return useCallback(() => {
    trackBookingButtonClick(gaLabel, source);
    dispatch(checkBookingExists(navigationHandler));
  }, [source, gaLabel, dispatch, navigationHandler]);
}
